import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Footer from './components/Footer';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import MobileHeader from './components/MobileHeader';
import MobileNavigation from './components/MobileNavigation';
import MobileMenuDrawer from './components/MobileMenuDrawer';
import PaymentWarningBanner from './components/PaymentWarningBanner';
import KTLayout from './theme/app/layouts/demo1';
import KTComponent from './metronic/core';
import AuthenticationFailure from './routes/AuthenticationFailure';
import LoadingSpinner from './components/LoadingSpinner';
import { PageHeaderProvider } from './contexts/PageHeaderContext';

const AuthLayout = () => {
    const {
        isAuthenticated,
        loading,
        authenticationError
    } = useAuth();

    useEffect(() => {
        KTComponent.init();
        KTLayout.init();
    }, []);

    if (authenticationError) {
        return <AuthenticationFailure />
    }

    if (loading) {
        return (
            <LoadingSpinner fullScreen />
        );
    }

    return isAuthenticated ? (
        <PageHeaderProvider>
            {/* Desktop Layout */}
            <div className="hidden lg:flex grow">
                <Sidebar />
                <div className="wrapper flex grow flex-col">
                    <Header />
                    <PaymentWarningBanner />
                    <main className="grow content" id="content" role="content">
                        <Outlet />
                    </main>
                    <Footer />
                </div>
            </div>

            {/* Mobile Layout */}
            <div className="lg:hidden flex flex-col min-h-screen">
                <MobileHeader />
                <PaymentWarningBanner />
                <main className="flex-1 pt-14 pb-16 overflow-y-auto" id="mobile-content">
                    <Outlet />
                </main>
                <MobileNavigation />
                <MobileMenuDrawer />
            </div>

            {/* <SearchModal />*/}
        </PageHeaderProvider>
    ) : <Navigate to="/auth/login" />;
};

export default AuthLayout;
